<template>
    <!-- Toggle button container -->
    <div class="d-flex justify-space-around pa-6">
      <!-- Vuetify toggle button component for grouping buttons -->
      <v-btn-toggle
        rounded="xl"
        mandatory="force"
        divided
        variant="outlined"
        :model-value="modelValue"
        @update:model-value="updateModelValue"
      >
        <!-- Button for Video option -->
        <v-btn>
          <!-- If selected, display checkmark -->
          <i v-if="modelValue==0" class="mdi mdi-check"></i>
          Video
        </v-btn>

        <!-- Button for Reading option -->
        <v-btn>
          <!-- If selected, display checkmark. -->
          <i v-if="modelValue" class="mdi mdi-check"></i>
          Reading
        </v-btn>
      </v-btn-toggle>
    </div>
</template>

<script>
export default {
    name: 'ToggleButton',
    props: {
        'modelValue': Number,
        'valueString': String
    },
    emits: ['update:modelValue', 'update:valueString'],
    methods: {
        // Method to update modelValue and valueString props
        updateModelValue(newValue){
            this.$emit('update:modelValue', newValue);
            this.$emit('update:valueString', (newValue) ? "Reading":"Video");
        }
    } 
}

</script>
<style scoped>
/* MEND branding for text */
* { 
    font-family: 'Montserrat';
}
</style>